import React from 'react';
import { CheckCircle2, Lock, ArrowRight, Phone, ShieldCheck } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  return <section className="relative bg-gradient-to-b from-glass to-white pt-8 pb-10 lg:pt-10 lg:pb-12 overflow-hidden" data-id="element-107">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-108">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-blue-50/50 blur-3xl" data-id="element-109" />
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-glass-dark/40 blur-3xl" data-id="element-110" />
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-7xl" data-id="element-111">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 items-center" data-id="element-112">
          {/* Left Column: Copy */}
          <div className="lg:col-span-7 xl:col-span-6" data-id="element-113">
            <FadeIn data-id="element-114">
              <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white border border-blue-100 shadow-sm mb-3" data-id="element-115">
                <span className="flex h-2 w-2 rounded-full bg-primary animate-pulse" data-id="element-116"></span>
                <span className="text-xs md:text-sm font-semibold text-navy" data-id="element-117">
                  Free In-Home Shower Glass Quotes Available
                </span>
              </div>

              <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-[2.6rem] font-bold text-navy leading-[1.1] mb-3 tracking-tight" data-id="element-118">
                Custom Glass Shower Doors &{' '}
                <span className="text-primary" data-id="element-119">
                  Frameless Shower Enclosures
                </span>{' '}
                in Southeast Michigan
              </h1>

              <p className="text-sm lg:text-base text-gray-600 mb-4 leading-relaxed max-w-2xl" data-id="element-120">
                Upgrade your bathroom with custom glass shower doors designed,
                measured, fabricated and installed by Kosin's Glass. Choose from
                frameless, Euro, semi-frameless, framed, sliding and tub
                enclosure options with premium glass, quality hardware and
                professional installation.
              </p>

              <ul className="space-y-2 mb-4" data-id="element-121">
                {['Custom measured and fabricated for your exact shower or tub opening', 'Frameless, Euro, semi-frameless, framed, sliding and walk-in shower glass options', '18 glass designs and textures plus multiple hardware finishes, colors and styles', 'Free in-home quote, professional installation and lifetime installation guarantee'].map((bullet, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-122">
                    <CheckCircle2 className="w-4 h-4 lg:w-5 lg:h-5 text-primary shrink-0 mt-0.5" data-id="element-123" />
                    <span className="text-sm text-gray-700 font-medium leading-snug" data-id="element-124">
                      {bullet}
                    </span>
                  </li>)}
              </ul>

              <div className="flex items-center gap-2 text-xs text-gray-500 bg-gray-50 inline-flex px-3 py-1.5 rounded-lg border border-gray-100" data-id="element-125">
                <Lock className="w-3.5 h-3.5 text-gray-400" data-id="element-126" />
                <span data-id="element-127">
                  Your information is secure. Kosin's Glass will never share
                  your details.
                </span>
              </div>
            </FadeIn>
          </div>

          {/* Right Column: Form */}
          <div className="lg:col-span-5 xl:col-span-5 xl:col-start-8" id="quote-form" data-id="element-128">
            <FadeIn delay={0.2} direction="left" data-id="element-129">
              <div className="bg-white rounded-2xl shadow-soft border border-gray-100 p-5 md:p-6 relative overflow-hidden" data-id="element-130">
                <div className="absolute top-0 left-0 w-full h-1 bg-primary" data-id="element-131"></div>

                <div className="inline-block bg-glass text-primary text-[10px] font-bold uppercase tracking-wider py-1 px-2.5 rounded mb-3" data-id="element-132">
                  Free In-Home Quote
                </div>

                <h3 className="text-xl lg:text-2xl font-bold text-navy mb-1.5 tracking-tight" data-id="element-133">
                  Request a Shower Glass Quote
                </h3>
                <p className="text-xs lg:text-sm text-gray-600 mb-4 leading-relaxed" data-id="element-134">
                  Submit your details and a Kosin's Glass team member will
                  contact you to confirm your bathroom layout, photos, rough
                  measurements, remodel stage, glass style and hardware
                  preferences.
                </p>

                <form className="space-y-3" onSubmit={e => e.preventDefault()} data-id="element-135">
                  <div data-id="element-136">
                    <label htmlFor="fullName" className="block text-xs font-semibold text-navy mb-1" data-id="element-137">
                      Full Name
                    </label>
                    <input type="text" id="fullName" placeholder="John Smith" className="w-full px-3.5 py-2.5 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all bg-gray-50 focus:bg-white text-sm" required data-id="element-138" />
                  </div>
                  <div data-id="element-139">
                    <label htmlFor="phone" className="block text-xs font-semibold text-navy mb-1" data-id="element-140">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" placeholder="(555) 123-4567" className="w-full px-3.5 py-2.5 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all bg-gray-50 focus:bg-white text-sm" required data-id="element-141" />
                  </div>
                  <div data-id="element-142">
                    <label htmlFor="email" className="block text-xs font-semibold text-navy mb-1" data-id="element-143">
                      Email Address
                    </label>
                    <input type="email" id="email" placeholder="john@email.com" className="w-full px-3.5 py-2.5 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all bg-gray-50 focus:bg-white text-sm" required data-id="element-144" />
                  </div>

                  <button type="submit" className="w-full bg-primary hover:bg-primary-hover text-white font-semibold py-3 px-6 rounded-xl transition-colors flex items-center justify-center gap-2 group mt-1 text-sm" data-id="element-145">
                    Request My Free Shower Quote
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-146" />
                  </button>
                </form>

                <div className="mt-4 text-center" data-id="element-147">
                  <a href="tel:5175457772" className="inline-flex items-center gap-1.5 text-xs lg:text-sm font-medium text-navy hover:text-primary transition-colors" data-id="element-148">
                    <Phone className="w-3.5 h-3.5" data-id="element-149" />
                    Prefer to call? Howell Main Service Center: 517-545-7772
                  </a>
                </div>

                <div className="mt-3 text-center border-t border-gray-100 pt-3" data-id="element-150">
                  <p className="text-[10px] text-gray-400 flex items-center justify-center gap-1" data-id="element-151">
                    <ShieldCheck className="w-3 h-3" data-id="element-152" />
                    We respect your privacy. Your details are safe with us.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}
export function TrustBar() {
  const items = ['Free In-Home Quotes', 'Custom Measured', 'Frameless & Euro Options', '18 Glass Textures', 'Hardware Finish Options', 'Professional Installation', 'Lifetime Installation Guarantee', 'Howell, Ann Arbor & Novi'];
  return <div className="bg-navy py-6 border-y border-navy-800" data-id="element-153">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-154">
        <div className="flex flex-wrap justify-center gap-3 md:gap-6 lg:gap-8" data-id="element-155">
          {items.map((item, i) => <FadeIn key={i} delay={i * 0.05} direction="none" className="flex items-center gap-2" data-id="element-156">
              <CheckCircle2 className="w-4 h-4 text-primary" data-id="element-157" />
              <span className="text-sm md:text-base font-medium text-white whitespace-nowrap" data-id="element-158">
                {item}
              </span>
            </FadeIn>)}
        </div>
      </div>
    </div>;
}